import React from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import { colors } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Button,
  ListItem
} from '@mui/material';
import { makeStyles } from '@mui/styles'
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

const useStyles = makeStyles((theme) => ({
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightMedium,
    justifyContent: 'flex-start',
    letterSpacing: 0,
    padding: '10px 8px',
    textTransform: 'none',
    width: '100%'
  },
  icon: {
    marginRight: theme.spacing(1)
  },
  title: {
    marginRight: 'auto'
  }
}));

const NavItem = ({
  className,
  href,
  icon: Icon,
  title,
  onButtonClick,
  selected,
  showExpand,
  expandOpen,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <ListItem
      className={clsx(classes.item, className)}
      disableGutters
      {...rest}
    >
      {onButtonClick ?
      <Button
        className={classes.button}
        onClick={() => onButtonClick()}
      >
        {Icon && (
          <Icon
            className={classes.icon}
            size="20"
          />
        )}
        <span className={classes.title}>
          {title}
        </span>
        {showExpand ? (expandOpen ? <ExpandLess /> : <ExpandMore />) : null}
      </Button>
      :
      <Button
        className={classes.button}
        component={RouterLink}
        to={href}
        style={{color : selected ? '#005EB8' : colors.blueGrey[600]}}
      >
        {Icon && (
          <Icon
            className={classes.icon}
            size="20"
          />
        )}
        <span className={classes.title}>
          {title}
        </span>
      </Button>
      }
    </ListItem>
  );
};

NavItem.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  title: PropTypes.string
};

export default NavItem;
